<div *ngIf="flatAdjustmentIds" class="mb-27">
  <ng-container *ngIf="isLineItemAdjustments">
    <ng-container *ngFor="let lineItem of invoice.LineItems">
      <ng-container *ngFor="let adjustment of lineItem.Adjustments">
        <wl-invoice-adjustment-edit
          [adjustment]="adjustment"
          [lineItem]="lineItem"
          [flatAdjustmentIds]="flatAdjustmentIds"
          [adjustmentTypes]="adjustmentTypes"
          [allRevenueItems]="allRevenueItems"
        ></wl-invoice-adjustment-edit>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!isLineItemAdjustments">
    <ng-container *ngFor="let lineItem of invoice.LineItems">
      <ng-container *ngFor="let payment of lineItem.Payments">
        <ng-container *ngFor="let adjustment of payment.Adjustments">
          <wl-invoice-adjustment-edit
            [adjustment]="adjustment"
            [lineItem]="lineItem"
            [payment]="payment"
            [flatAdjustmentIds]="flatAdjustmentIds"
            [adjustmentTypes]="adjustmentTypes"
          ></wl-invoice-adjustment-edit>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
